import { render, staticRenderFns } from "./ds-report-chart.vue?vue&type=template&id=41c039be&scoped=true"
import script from "./ds-report-chart.vue?vue&type=script&lang=js"
export * from "./ds-report-chart.vue?vue&type=script&lang=js"
import style0 from "./ds-report-chart.vue?vue&type=style&index=0&id=41c039be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c039be",
  null
  
)

export default component.exports